import { render, staticRenderFns } from "./InlineBoxSimpleLayout.vue?vue&type=template&id=eec1eeb0"
import script from "./InlineBoxSimpleLayout.vue?vue&type=script&lang=js"
export * from "./InlineBoxSimpleLayout.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxSimpleLayout.vue?vue&type=style&index=0&id=eec1eeb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports